// extracted by mini-css-extract-plugin
export default {"container":"menu-list_container__Bi3WB","title":"menu-list_title__uA9Jr","items":"menu-list_items__gkJxY","item":"menu-list_item__PvO5+"};